import * as CookieConsent from 'vanilla-cookieconsent';

export const COOKIE_CATEGORIES = {
  NECESSARY: 'necessary',
  ANALYTICS: 'analytics',
  PREFERENCES: 'preferences',
};

let consentStatusOverride = null;

export function isConsentGiven(category) {
  if (consentStatusOverride && Object.prototype.hasOwnProperty.call(consentStatusOverride, category)) {
    return consentStatusOverride[category] === true;
  }

  return CookieConsent.acceptedCategory(category);
}

export function getConsentStatus() {
  return {
    necessary: isConsentGiven(COOKIE_CATEGORIES.NECESSARY),
    analytics: isConsentGiven(COOKIE_CATEGORIES.ANALYTICS),
    preferences: isConsentGiven(COOKIE_CATEGORIES.PREFERENCES),
  };
}

export function __setConsentStatusOverrideForTests(nextOverride) {
  consentStatusOverride = nextOverride && typeof nextOverride === 'object'
    ? { ...nextOverride }
    : null;
}
